import React, { useRef, useState } from 'react';
import DataServiceSQL from "../DataService/DataServiceSQL";
import { Col, Row } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../Pages/Constants';
import cookie from 'react-cookies';
import {FormattedMessage} from 'react-intl';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';


import Utils from '../Components/Common/Utils.js';
import CopyableId from '../Components/Common/CopyableId.js';
import { userIsSuperAdmin } from '../Controller/userRoles.js';

const Account = (props) => {
    const { classes } = props;

    const [deleteUserAccountPage, setDeleteUserAccountPage] = useState(0)
    const [errorMessage, setErrorMessage] = useState(false)
    const [changeOngoing, setChangeOngoing] = useState(false)
    const inputRef = useRef(null);
    const [activeTab, setActiveTab] = useState('1');
    const [logsList, setLogsList] = useState([]);
    const [dayBegin, setDayBegin] = useState("")
    const [dayEnd, setDayEnd] = useState("")

    const wait = (n) => new Promise((resolve) => setTimeout(resolve, n));

    const renderBasicUserData = (accountInformation) => {
        const showDebug = userIsSuperAdmin(props.accountInformation);
        return(
            <div>
                <br/>
                <b><FormattedMessage id="account.email" defaultMessage="Email address" /> :</b> {props.accountInformation.email} <br/>
                <b><FormattedMessage id="account.firstname" defaultMessage="Firstname" /> :</b> {props.accountInformation.firstName} <br/>
                <b><FormattedMessage id="account.lastname" defaultMessage="Lastname" /> :</b> {props.accountInformation.lastName} <br/>
                {showDebug && props.accountInformation.id_user ? (
                    <div>
                        <b>id_user:</b>{" "}
                        <CopyableId value={props.accountInformation.id_user} />
                    </div>
                ) : null}
                {showDebug ? (
                    <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "4px" }}>
                        <input
                            type="checkbox"
                            id="hideAdminMenu"
                            checked={!!props.hideAdminMenu}
                            onChange={props.toggleHideAdminMenu}
                            style={{ cursor: "pointer" }}
                        />
                        <label htmlFor="hideAdminMenu" style={{ margin: 0, cursor: "pointer", fontWeight: "normal" }}>
                            <FormattedMessage id="account.hideAdminMenu" defaultMessage="Masquer le menu admin" />
                        </label>
                    </div>
                ) : null}
                {showDebug && props.accountInformation.profession ? (
                    <div>
                        <b>profession:</b>{" "}
                        <span style={{ fontFamily: "monospace", fontSize: "0.9em" }}>
                            {props.accountInformation.profession}
                        </span>
                        <CopyableId value={props.accountInformation.profession} prefixLength={32} />
                    </div>
                ) : null}
                <br/>
            </div>
        )
    }  

    const renderUsername = (accountInformation) => {
        if((accountInformation.category !== undefined && accountInformation.category !== null && accountInformation.category !== "null" && accountInformation.category !== "") ||
           (accountInformation.profession !== undefined && accountInformation.profession !== null && accountInformation.profession !== "null" && accountInformation.profession !== "") ||
           (accountInformation.mssantemail !== undefined && accountInformation.mssantemail !== null && accountInformation.mssantemail !== "null" && accountInformation.mssantemail !== "")) {
                return(
                    <div>
                    <b><FormattedMessage id="account.RPPS_num" defaultMessage="RPPS number" /> :</b> {accountInformation.username} <br/>
                    </div>
                )
        }
        else if (accountInformation.username !== undefined && accountInformation.username !== null && accountInformation.username !== "null" && accountInformation.username !== "") {
            return(
                <div>
                <b><FormattedMessage id="account.username" defaultMessage="Username" /> :</b> {accountInformation.username} <br/>
                </div>
            )
        }
        else {
            return null
        }
    }

    const renderAnsData = (accountInformation) => {
        return(
            <div>
                {renderUsername(accountInformation)}
                {((accountInformation.INS_Data.NomNaissance !== undefined)&&(accountInformation.INS_Data.NomNaissance !== null)&&(accountInformation.INS_Data.NomNaissance !== "null")&&(props.accountInformation.profession !== null)&&(accountInformation.profession !== "null")&&(accountInformation.profession !== "")) ?
                    <div>
                    <b><FormattedMessage id="account.exercise_name" defaultMessage="Exercise name" /> :</b> {accountInformation.lastName} <br/>
                    </div>
                    :
                    null
                }
                {(((accountInformation.INS_Data.NomNaissance !== undefined)&&(accountInformation.INS_Data.NomNaissance !== null)&&(accountInformation.INS_Data.NomNaissance !== "null"))&&((accountInformation.profession === null)||(props.accountInformation.profession === "null")||(accountInformation.profession === ""))) ?
                    <div>
                    <b><FormattedMessage id="account.lastname" defaultMessage="Lastname" /> :</b> {accountInformation.INS_Data.NomNaissance} <br/>
                    </div>
                    :
                    null
                }
                {((accountInformation.category !== undefined)&&(accountInformation.category !== null)&&(accountInformation.category !== "null")&&(accountInformation.category !== "")) ?
                    <div>
                    <b><FormattedMessage id="account.categoryTitle" defaultMessage="Category" /> :</b>{" "}
                    <FormattedMessage id="account.category" defaultMessage=" " values={{category: accountInformation.category}} />
                    </div>
                    :
                    null
                }
                {((accountInformation.profession !== undefined)&&(accountInformation.profession !== null)&&(accountInformation.profession !== "null")&&(accountInformation.profession !== "")) ?
                    <div>
                    <b><FormattedMessage id="account.professionTitle" defaultMessage="Profession" /> :</b>{" "}
                    <FormattedMessage id="account.profession" defaultMessage=" " values={{profession: accountInformation.profession}} />
                    </div>
                    :
                    null
                }
                {(accountInformation.mssantemail !== undefined && accountInformation.mssantemail !== null && accountInformation.mssantemail !== "null" && accountInformation.mssantemail !== "") ?
                    <div>
                    <b><FormattedMessage id="account.mssantemail" defaultMessage="MSSanté email" /> :</b> {accountInformation.mssantemail} <br/>
                    </div>
                    :
                    null
                }                
            </div>
        )
    }   

    const renderStructureAndRole = () => {
        let role = Utils.convertRoleToText(props.accountInformation.role, props.accountInformation.readOnly)
        return(
            <div>
                {(props.accountInformation.role === "admin" || props.accountInformation.role === "staff") ?
                    <left>
                        <hr/>                     
                        <b><FormattedMessage id="account.structure" defaultMessage="Structure:"/></b>
                        <br/>
                        <FormattedMessage id="account.structure.info" defaultMessage="" values={{struct_name: props.struct_info.struct_name, role:role}}/>  <br/>
                        {props.accountInformation.struct_type && (
                            <span>
                                <b><FormattedMessage id="account.structureType" defaultMessage="Type de structure" /> :</b>{" "}
                                <span style={{ fontFamily: "monospace", fontSize: "0.9em" }}>{props.accountInformation.struct_type}</span>
                            </span>
                        )}
                    </left>
                    :
                    Utils.convertRoleToText(props.accountInformation.role, props.accountInformation.readOnly)
                }
            </div>
        )
    }                                

    const dayBeginOnChange = (e) => {
        setDayBegin(e)
        setChangeOngoing(true)
    }

    const dayEndOnChange = (e) => {
        setDayEnd(e)
        setChangeOngoing(true)
    }

    const updateHoursSchedule = async () => {
        let date_begin_utc = new Date(Date.UTC(0, 0, 0, 0, 0, 0))
        date_begin_utc.setUTCHours(dayBegin.split(':')[0])
        date_begin_utc.setUTCMinutes(dayBegin.split(':')[1])
        date_begin_utc.setTime(date_begin_utc.getTime() + (60000 * new Date().getTimezoneOffset()))
        let date_end_utc = new Date(Date.UTC(0, 0, 0, 0, 0, 0))
        date_end_utc.setUTCHours(dayEnd.split(':')[0])
        date_end_utc.setUTCMinutes(dayEnd.split(':')[1])
        date_end_utc.setTime(date_end_utc.getTime() + (60000 * new Date().getTimezoneOffset()))

        let day_time = date_begin_utc.toISOString().split('T')[1].substring(0, 5) + ',' + date_end_utc.toISOString().split('T')[1].substring(0, 5)
        let night_time = date_end_utc.toISOString().split('T')[1].substring(0, 5) + ',' + date_begin_utc.toISOString().split('T')[1].substring(0, 5)
        let schedule_hours = {day: day_time, night: night_time}
        var data = {
          "resourceType" : "Practitioner",
          "schedule_hours": schedule_hours
        }
        await (DataServiceSQL.updatePractitionnerReq_fhir(props.accountInformation.username, data))
          .then((response) => {
            setChangeOngoing(false);
          })
          .catch((e) => {
            console.log(e);
          });
    }

    const renderHoursSchedule = () => {
        if (dayBegin === "") {
            setDayBegin(props.struct_info.hours_schedule.day.split(',')[0])
        }
        if (dayEnd === "") {
            setDayEnd(props.struct_info.hours_schedule.day.split(',')[1])
        }
        return(
            <div>
                {(props.accountInformation.role === "admin") || (props.accountInformation.role === "staff") ?
                    <left>
                        <hr/>
                        <b><FormattedMessage id="account.structure.hours_schedule" defaultMessage="Hours schedule"/></b>
                        <br/>
                        <Row style={{margin:0}}>
                            <FormattedMessage id="account.structure.hours_schedule.day" defaultMessage="Day"/>
                        </Row>
                        <Row style={{margin:0}}>
                            <Col style={{padding:0, flexDirection: 'row', display:"flex", alignItems:"center", justifyContent:'left'}}>
                                <FormattedMessage id="account.structure.hours_schedule.begin" defaultMessage="Begin"/>:
                                <input type="time" id="start_day" key="0" name="start_day" value={dayBegin} style={{border: "1px solid gray"}} onChange={e => dayBeginOnChange(e.target.value)} readOnly={props.accountInformation.readOnly === true}/>
                            </Col>
                            <Col style={{flexDirection: 'row', display:"flex", alignItems:"center", justifyContent:'center'}}>
                                <FormattedMessage id="account.structure.hours_schedule.end" defaultMessage="End"/>:
                                <input type="time" id="end_day" key="1" name="end_day" value={dayEnd} style={{border: "1px solid gray"}} onChange={e => dayEndOnChange(e.target.value)} readOnly={props.accountInformation.readOnly === true}/>
                            </Col>
                            <Col style={{flexDirection: 'row', display:"flex", alignItems:"center", justifyContent:'right'}}>
                            </Col>
                        </Row>
                        <Row style={{margin:0}}>
                            <FormattedMessage id="account.structure.hours_schedule.night" defaultMessage="Night"/>
                        </Row>
                        <Row style={{margin:0}}>
                            <Col style={{padding:0, flexDirection: 'row', display:"flex", alignItems:"center", justifyContent:'left'}}>
                                <FormattedMessage id="account.structure.hours_schedule.begin" defaultMessage="Begin"/>:
                                <input type="time" id="start_night" key="0" name="start_night" value={dayEnd} style={{border: "1px solid gray"}} onChange={e => dayEndOnChange(e.target.value)} readOnly={props.accountInformation.readOnly === true}/>
                            </Col>
                            <Col style={{flexDirection: 'row', display:"flex", alignItems:"center", justifyContent:'center'}}>
                                <FormattedMessage id="account.structure.hours_schedule.end" defaultMessage="End"/>:
                                <input type="time" id="end_night" key="1" name="end_night" value={dayBegin} style={{border: "1px solid gray"}} onChange={e => dayBeginOnChange(e.target.value)} readOnly={props.accountInformation.readOnly === true}/>
                            </Col>
                            <Col style={{flexDirection: 'row', display:"flex", alignItems:"center", justifyContent:'right'}}>
                                <button onClick={updateHoursSchedule} className="btn btn-success" disabled={!changeOngoing}>
                                    <FormattedMessage id="button.submit" defaultMessage="Submit" />
                                </button>
                            </Col>
                        </Row>
                    </left>
                    :
                    null
                }
            </div>
        )
    }                                

    const renderSubscriptionDetails = () => {
        let sub_available = props.subscription_info.sub_total - props.subscription_info.sub_used
        let correctDate = ""
        if (props.subscription_info.expiration_date !== undefined) {
            correctDate = new Date(props.subscription_info.expiration_date)
        }
        let isValidDate = Date.parse(correctDate);
        let date_options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        };
        return(
            <div>
                {(isNaN(isValidDate) || (props.accountInformation.role !== "admin" && props.accountInformation.role !== "staff")) ?
                    <area/>
                    :
                    <left>
                        <hr/>                 
                        <b><FormattedMessage id="account.subscription" defaultMessage="Subscription" /></b>
                        <br/>
                        <FormattedMessage id="account.subscriptionDetailsUsed" defaultMessage=" " values={{sub_used: props.subscription_info.sub_used}} />
                        <FormattedMessage id="account.subscriptionDetailsTotal" defaultMessage=" used licences on " values={{sub_total: props.subscription_info.sub_total}} />
                        <FormattedMessage id="account.subscriptionDetailsRemaining" defaultMessage=" ( remaining)" values={{sub_available: sub_available}} />
                        <FormattedMessage id="account.subscriptionDetailsDate" defaultMessage=", expiration date: " values={{Date: correctDate.toLocaleDateString(props.currentLocale, date_options)}} />
                    </left>
                }
            </div>
        )


    }


    const renderAccountActions = () => {
        let mailto_params = 'mailto:contact@e-takescare.com?subject=[Tucky Center]%20revoke%20MIE%20' + props.accountInformation.id_user
        return(
            <left>
                <hr/>  
                <b><FormattedMessage id="account.accountActions" defaultMessage="Account actions" /></b>
                <br/><br/>

                <h6 onClick={changeUserPwd} style={{color:"#FF0000", cursor: "pointer"}}>
                <FormattedMessage id="account.changePwd" defaultMessage="Change password"/></h6> 

                <h6 onClick={revokeMIE} style={{color:"#FF0000", cursor: "pointer"}}>
                <FormattedMessage id="account.revokeMIE" defaultMessage="Revoke a login method"/></h6>

                <h6 onClick={deleteUserAccount} style={{color:"#FF0000", cursor: "pointer"}}>
                <FormattedMessage id="account.deleteAccount" defaultMessage="Delete account database"/></h6>

                <h6 onClick={switchDeleteUserData} style={{color:"#FF0000", cursor: "pointer"}}>
                <FormattedMessage id="account.deleteData" defaultMessage="Delete data database"/></h6>
            </left>
        )
    }

    const renderNoLogs = (accountInformation) => {
        let multi_recipient_activated = Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("multi_recipient"))
        return(
            <div>
                {(props.accountInformation !== undefined) ?
                    <Row style={{width: "100%", fontSize:"120%"}}>
                        <div>
                            {renderBasicUserData(accountInformation)}
                            {renderAnsData(accountInformation)}
                            {renderStructureAndRole()}
                            {multi_recipient_activated ?
                                renderHoursSchedule()
                                :
                                null
                            }
                            {renderSubscriptionDetails()}
                            {renderAccountActions()}
                        </div>
                    </Row>
                    :
                    <Row style={{width: "100%", fontSize:"120%"}}>
                            <br/>
                            <b>information not available</b>
                    </Row>
                }
            </div>
        )
    }

    const renderLogs = () => {
        return(
            <div>
            {logsList.map(log => {
                let log_display = Utils.ins_format_log(log)
                let qualified_identity = JSON.parse(log.logValue).qualified_identity
                return (
                    <div style={{width:"100%"}}>
                        <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                           {log_display}
                           {qualified_identity ?
                            <FormattedMessage id="log.qualified" defaultMessage=" (qualified identity)"/>
                            :
                            null
                           }
                        </Row>
                        <br></br>
                    </div>
                )
            })}
            </div>
        )
    }

    const cancelDeleteUser = () => {
        setDeleteUserAccountPage(0)
    }

    const switchDeleteUserData = () => {
        setDeleteUserAccountPage(1)
    }

    const changeUserPwd = () => {
        // Link to keycloak user pwd change
        setErrorMessage(false)
        window.open("https://tuckycenteraccess2.azurewebsites.net/realms/tucky/account/#/security/signingin", '_blank', 'noopener,noreferrer')
    }

    const revokeMIE = () => {
        // Link to keycloak user pwd change
        setErrorMessage(false)
        window.open("https://tuckycenteraccess2.azurewebsites.net/realms/tucky/account/#/security/linked-accounts", '_blank', 'noopener,noreferrer')
    }

    const deleteUserAccount = () => {
        // Link to keycloak user delete
        setErrorMessage(false)
        window.open("https://tuckycenteraccess2.azurewebsites.net/realms/tucky/account/#/personal-info", '_blank', 'noopener,noreferrer')
    }

    const tabColor = () => {
        return "grey"
    }

    const deleteUserData = async () => {
        // Deletion of SQL user
        if (inputRef.current.value === "DELETE") {
            setErrorMessage(false)
            await DataServiceSQL.deleteUserReq_fhir(props.accountInformation.id_user)
              .then(async (response) => {
                setErrorMessage(<FormattedMessage id="message.success" defaultMessage="Success !" />)
                await wait(3000);
                props.keycloak.logout();
              })
              .catch((e) => {
                console.log(e)
                setErrorMessage(<FormattedMessage id="message.error.del.user" defaultMessage="Oups, did not work... (err_code del_user)" />)
              });
        }
        else {
            setErrorMessage(<FormattedMessage id="account.deleteIncorrect" defaultMessage="Incorrect code" />)
        }
    }

    if (deleteUserAccountPage === 0) {

        let accountInformation = Utils.ins_format_data(props.accountInformation);
        if (accountInformation.logs.length > 0 && logsList.length === 0) {
            let result = [];
            accountInformation.logs.forEach(log => {
                result.push(log);
            })
            setLogsList(result)
        }
        return (
            <div className={classes.popup_background}>
                <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                    <div className="submit-form">
                        <Row className="justify-content-md-end" style = {{ paddingBottom: "10px" }}>
                            <Col style={{ fontWeight: "bold", fontSize:"2.2em" }}>
                                <center>
                                    <FormattedMessage id="account.title" defaultMessage="Account" />
                                </center>
                            </Col>
                        </Row>
                        {(accountInformation.logs.length === 0) ?
                            <div>
                                {renderNoLogs(accountInformation)}
                            </div>
                            :
                            <div>
                            <Nav tabs style={{ backgroundColor:props.tabColor }}>
                                <NavItem style={{ backgroundColor:tabColor() }}>
                                    <NavLink className={activeTab === '1' ? 'active' : ''} onClick={() => setActiveTab('1')}>
                                        <FormattedMessage id="account.tab.title.general" defaultMessage="Données générales" />
                                    </NavLink>
                                </NavItem>
                                <NavItem style={{ backgroundColor:tabColor() }}>
                                    <NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => setActiveTab('2')}>
                                        <FormattedMessage id="account.tab.title.log_ins" defaultMessage="Logs ins" />
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    {renderNoLogs(accountInformation)}
                                </TabPane>
                                <TabPane tabId="2">
                                    {renderLogs()}
                                </TabPane>
                            </TabContent>
                            </div>
                        }
                        <center>
                            <button onClick={props.cancelPopup} className="btn btn-danger">
                              <FormattedMessage id="button.close" defaultMessage="Close" />
                            </button>
                        </center>
                    </div>
                </div>
            </div>
        );
    }
    else if (deleteUserAccountPage === 1) {
        return (
            <div className={classes.popup_background}>
                <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                    <div className="submit-form">
                        <Row className="justify-content-md-end" style = {{ paddingBottom: "10px" }}>
                            <Col style={{ fontWeight: "bold", fontSize:"2.2em" }}>
                                <center>
                                    <FormattedMessage id="account.deleteDataTitle" defaultMessage="Delete data" />
                                </center>
                            </Col>
                        </Row>
                        <Row style={{width: "100%", fontSize:"120%"}}>
                            <Col>
                                <FormattedMessage id="account.deleteDataMessage" defaultMessage='Do you really want to delete your data?' />
                                <br/>
                                <FormattedMessage id="account.deleteMessageConfirm" defaultMessage='If so, tap "DELETE" down here and validate.' />
                                <br/>
                                <b>
                                <FormattedMessage id="account.definitiveAction" defaultMessage='This action is final!' />
                                </b>
                                <center>
                                    {(errorMessage === false) ?
                                        <div>
                                        </div>
                                        :
                                        <div>
                                            {errorMessage}
                                        </div>
                                    }
                                    <br/>
                                    <input ref={inputRef} type="text" id="delete" name="delete"/>
                                    <button onClick={deleteUserData} className="btn btn-success">
                                        <FormattedMessage id="account.validationButton" defaultMessage="OK" />
                                    </button>
                                </center>
                            </Col>
                        </Row>
                        <center>
                            <button onClick={props.cancelPopup} className="btn btn-danger">
                              <FormattedMessage id="button.close" defaultMessage="Close" />
                            </button>
                        </center>
                    </div>
                </div>
            </div>
        );
    }
};
export default withStyles(Constants.styles)(Account);